import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDrawer } from 'services/drawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';
import { deleteSearchParams } from 'services/navigation/paths';

export const useCandidateReportDrawerParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { openDrawer } = useDrawer();
  const [initalLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (!initalLoad) return;
    setInitialLoad(false);
    const candidateId = searchParams.get('candidateId');
    if (!candidateId) return;
    openDrawer({
      drawerContentType: DrawerComponentType.CandidateReport,
      drawerComponentProps: {
        candidateId,
        candidateTableIndex: null,
        candidateIds: null
      },
      onClose: () => {
        deleteSearchParams({
          searchParams,
          key: 'candidateId',
          setSearchParams
        });
      }
    });
  }, [initalLoad, searchParams]);

  return {};
};
